import React, { useEffect, useState } from 'react';

const STRIPE_KEY =
  'pk_live_51NHYjrJSd3vy92GLD9BmvxSTi12RbjfSlSCy5DwoP7gq1mvYTtWNZlNFBINM7uekELSKvijqgPL6YaAJc1fIYN1e00ZMLNazwS';

/**
 * Loads Stripe.js only when mounted (provider app). Admin routes must not import this file.
 */
export default function StripeElementsProvider({ children, options, fallback = null }) {
  const [ready, setReady] = useState(false);
  const [ElementsComponent, setElementsComponent] = useState(null);
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const [{ loadStripe }, { Elements }] = await Promise.all([
        import('@stripe/stripe-js'),
        import('@stripe/react-stripe-js'),
      ]);

      const stripeInstance = await loadStripe(STRIPE_KEY);
      if (cancelled) {
        return;
      }

      setStripe(stripeInstance);
      setElementsComponent(() => Elements);
      setReady(true);
    })().catch((error) => {
      console.error('Could not load Stripe.js', error);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready || !ElementsComponent || !stripe) {
    return fallback ?? <div>Loading payments…</div>;
  }

  return (
    <ElementsComponent stripe={stripe} options={options}>
      {children}
    </ElementsComponent>
  );
}
